import { render, staticRenderFns } from "./OffCanvasDetailsAsiakas.vue?vue&type=template&id=c27e9490&scoped=true&"
import script from "./OffCanvasDetailsAsiakas.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsAsiakas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27e9490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c27e9490')) {
      api.createRecord('c27e9490', component.options)
    } else {
      api.reload('c27e9490', component.options)
    }
    module.hot.accept("./OffCanvasDetailsAsiakas.vue?vue&type=template&id=c27e9490&scoped=true&", function () {
      api.rerender('c27e9490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsAsiakas.vue"
export default component.exports